import './Funds.css';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { WalletContext } from './WalletContext';

function Funds({ onNavigateToAddFunds, onNavigateToWithdrawFunds, onNavigateToBankDetails, onNavigateToDepositHistory, onNavigateToWithdrawalHistory, onBack }) {
  const navigate = useNavigate();
  const { walletBalance } = useContext(WalletContext);
  const fundOptions = [
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="white">
          <rect x="8" y="10" width="16" height="14" rx="2" stroke="white" strokeWidth="2" fill="none"/>
          <path d="M12 10V8C12 6 13 4 16 4C19 4 20 6 20 8V10" stroke="white" strokeWidth="2"/>
          <circle cx="16" cy="18" r="1.5" fill="white"/>
          <path d="M16 19.5V22" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          <line x1="15" y1="16" x2="17" y2="16" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          <line x1="16" y1="15" x2="16" y2="17" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      ),
      title: 'Add Fund',
      description: 'You can add fund to your wallet',
      onClick: onNavigateToAddFunds
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="white">
          <circle cx="16" cy="16" r="11" stroke="white" strokeWidth="2" fill="none"/>
          <path d="M16 8V16L21 19" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          <path d="M10 6L8 4M22 6L24 4M6 10L4 8M26 10L28 8" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      ),
      title: 'Add History',
      description: 'You can check your add fund history',
      onClick: onNavigateToDepositHistory
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="white">
          <path d="M16 8V20M16 20L12 16M16 20L20 16" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          <rect x="8" y="20" width="16" height="6" rx="1" stroke="white" strokeWidth="2" fill="none"/>
          <line x1="12" y1="23" x2="20" y2="23" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      ),
      title: 'Withdraw Funds',
      description: 'You can add withdraw winnings',
      onClick: onNavigateToWithdrawFunds
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="white">
          <circle cx="16" cy="16" r="11" stroke="white" strokeWidth="2" fill="none"/>
          <path d="M16 8V16L21 19" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          <path d="M10 6L8 4M22 6L24 4M6 10L4 8M26 10L28 8" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      ),
      title: 'Withdraw History',
      description: 'You can check your withdraw history',
      onClick: onNavigateToWithdrawalHistory
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="white">
          <rect x="6" y="12" width="20" height="14" rx="1" stroke="white" strokeWidth="2" fill="none"/>
          <path d="M10 12V10C10 8 11 6 16 6C21 6 22 8 22 10V12" stroke="white" strokeWidth="2"/>
          <rect x="10" y="16" width="4" height="6" rx="1" fill="white"/>
          <rect x="18" y="16" width="4" height="6" rx="1" fill="white"/>
          <rect x="14" y="16" width="4" height="6" rx="1" fill="white"/>
        </svg>
      ),
      title: 'Add Bank Details',
      description: 'Add your bank details for withdraw',
      onClick: onNavigateToBankDetails
    }
  ];

  return (
    <div className="funds-page">
      <div className="funds-header">
        <button className="back-btn" onClick={onBack}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </button>
        <h1>Funds</h1>
        <button className="wallet-btn" onClick={() => navigate("/funds")}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <rect x="2" y="6" width="20" height="14" rx="2" stroke="white" strokeWidth="2"/>
            <path d="M2 10H22" stroke="white" strokeWidth="2"/>
            <circle cx="18" cy="15" r="1.5" fill="white"/>
          </svg>
          <span className="wallet-balance">₹ {walletBalance}</span>
        </button>
      </div>
      
      <div className="funds-container">
        {fundOptions.map((option, index) => (
          <button 
            key={index} 
            className="fund-card"
            onClick={option.onClick}
          >
            <div className="fund-icon">
              {option.icon}
            </div>
            <div className="fund-content">
              <h3 className="fund-title">{option.title}</h3>
              <p className="fund-description">{option.description}</p>
            </div>
            <svg className="fund-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M9 6L15 12L9 18" stroke="#1a1a1a" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        ))}
      </div>
    </div>
  );
}

export default Funds;
